import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-fela'
import Container from 'views/components/presentationals/atoms/Container'
import NavBar from 'views/layouts/NavBar'
import ds from 'views/styles/designSystem'
import { pxTo } from 'design-system-utils'
import Icon from 'views/components/presentationals/Icon'

const Header = ({ styles }) => (
  <header className={styles.header}>
    <Container className={styles.container}>
      <div className={styles.imgWrapper}>
        <a href="https://glinko.fr/">
          <Icon name="logo-glinko-white" />
        </a>
      </div>
      <NavBar />
    </Container>
  </header>
)

Header.propTypes = {
  styles: PropTypes.object.isRequired,
}

const rules = {
  header: () => ({
    backgroundColor: ds.brand('blueNight'),
    color: ds.brand('greyLighter'),
  }),
  container: () => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: pxTo(80, ds.get('type.baseFontSize'), 'rem'),
    margin: '0 auto',
    maxWidth: '100%',
    padding: `0 ${pxTo(ds.get('layout.gutter') / 2, ds.get('type.baseFontSize'), 'rem')}`,
  }),
  imgWrapper: () => ({
    height: '100%',
    '> a': {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      height: '100%',
    },
  }),
}

export default connect(rules)(Header)
